module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_maedori@2x-07f4abc12fd540ec3db2b04d4dba686b.webp";